<app-modal>
  <app-loading *ngIf="loading"></app-loading>
  <ng-container *ngIf="!loading">
    <app-modal-header
      [title]="T.control.add_incident.one | translate"
      [showDelete]="false"
      (closed)="confirmClose()">
    </app-modal-header>

    <app-modal-body>
      <section class="row col-row-space custom-gutters section-padding">
        <div class="col-12 qa-incident-title" [formGroup]="incidentForm">
          <app-text-field
            [autofocus]="true"
            formControlName="title"
            [placeholder]="(T.defaultLocalizations.title.one | translate) + '*'"
            [displayError]="triggerErrors"
            [required]="true"
            [disableMargin]="true"
            [formGroup]="incidentForm"
            [useReactiveMessages]="true">
          </app-text-field>
        </div>
        <div class="col-12">
          <app-severity-selector
            [currentlySelectedSeverityCheckpoint]="severityCheckpoint"
            (checkpointSelected)="onSeverityCheckpointSelected($event)">
          </app-severity-selector>
        </div>
      </section>

      <app-accordion-details [collapsing]="false" [emphasizedHeaders]="true">
        <app-accordion-item-details [title]="T.common.details | translate" [expanded]="false">
          <ng-template accordionContent>
            <section class="row col-row-space custom-gutters section-padding">
              <div class="col-12">
                <app-text-field
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="incident.headlineStatus"
                  name="headlineStatus"
                  [placeholder]="T.defaultLocalizations.headline_status.one | translate"
                  [maxLength]="255"
                  [minLength]="3"
                  [required]="false">
                </app-text-field>
              </div>

              <div class="col-12 qa-incident-description">
                <app-details-editable-field
                  [input]="incident.description ? incident.description : ''"
                  [minLength]="0"
                  [type]="editableFieldTypes.RichText"
                  [placeholder]="T.common.add_description | translate"
                  [canEdit]="true"
                  (onUpdate)="updateDescription($event)"
                  (isInvalid)="isDescriptionInvalid($event)"
                ></app-details-editable-field>
              </div>

              <div class="col-12 qa-incident-category">
                <app-filter-dropdown-new
                  [singleSelect]="true"
                  [filterByModuleObjectType]="false"
                  [filterType]="filterTypes.Incident_Category"
                  [appliedFilters]="filters"
                  [typeahead]="true"
                  [required]="true"
                  [currentlySelectedSettingValue]="selectedCategory?.id"
                  [label]="(T.common.add_item | translate: { item: T.defaultLocalizations.incident_category.many | translate })"
                  (onFilterUpdate)="handleFilterChange($event, filterTypes.Incident_Category)">
                </app-filter-dropdown-new>
              </div>

              <div class="col-12">
                <app-text-field
                  [(ngModel)]="incident.reportedBy"
                  name="reportedBy"
                  [placeholder]="T.defaultLocalizations.reported_by.one | translate"
                  [maxLength]="120"
                  [minLength]="3">
                </app-text-field>
              </div>

              <div *ngIf="showPrivacyStatus" class="checkbox-wrapper col-12">
                  <app-checkbox
                  [isChecked]="privacyStatus.key !== privacyStatusesEnum.Open"
                  (checked)="onMakeConfidentialChecked($event)">
                </app-checkbox>
                <span> {{ T.common.make_confidential | translate }} </span>
              </div>

              <div *ngIf="showPrivacyStatus && showConfidentialStatuses" class="col-12">
                <app-simple-dropdown
                  #searchDropdown
                  [objects]="filteredStatuses"
                  [bindProperty]="'value'"
                  [label]="T.defaultLocalizations.privacy_status.one | translate"
                  [currentlySelectedObject]="privacyStatus"
                  (objectSelected)="onPrivacyStatusSelected($event)">
                </app-simple-dropdown>
              </div>

              <div class="col-12 qa-incident-endTime">
                <app-optional-date-time
                  [firstDateString]="incident.startTime"
                  [firstDateMaxTime]="startMaxDate"
                  [secondDateString]="incident.endTime"
                  [showPickers]="showPickers"
                  [editMode]="true"
                  (onFirstDateChanged)="onStartTimeChanged($event)"
                  (onSecondDateChanged)="onEndTimeChanged($event)"
                  (onShowPickersChanged)="onShowPickersChanged($event)"
                ></app-optional-date-time>
              </div>
              <div *ngIf="isCalledFromPIR && copiedEventFilter" class="col-12 checkbox-wrapper copy-event-checkbox">
                <app-checkbox
                  [isChecked]="copyEventFromPIR"
                  (checked)="copyEventFromPIR = $event"
                >
                </app-checkbox>
                <span>{{ T.common.copy_event_from_incoming_report | translate }}</span>
              </div>

            </section>
          </ng-template>
        </app-accordion-item-details>
        <app-accordion-item-details [title]="T.common.location.one | translate" [expanded]="false">
          <ng-template accordionContent>
            <section class="row col-row-space custom-gutters section-padding">
              <div class="col-12 qa-incident-zone">
                <app-filter-dropdown-new
                  [label]="T.common.add_item | translate: { item: localisedZones }"
                  [filterType]="filterTypes.Zone"
                  [filterByModuleObjectType]="false"
                  [appliedFilters]="filters"
                  [typeahead]="true"
                  (onFilterUpdate)="handleFilterChange($event)">
                </app-filter-dropdown-new>
                <span class="subtext mt-1 mt-sm-0">{{
                  T.common.which_items_are_affected | translate: { items: localisedZones }
                }}</span>
              </div>

              <div class="col-12 qa-incident-area">
                <app-filter-dropdown-new
                  [ngClass]="applicableAreaFilters.length === 0 ? 'area-filter-dropdown' : ''"
                  [label]="T.common.add_item | translate: { item: localisedAreas }"
                  [filterType]="filterTypes.Area"
                  [filterByModuleObjectType]="false"
                  [appliedFilters]="filters"
                  [typeahead]="true"
                  [usePredefinedFilters]="true"
                  [predefinedFilters]="applicableAreaFilters"
                  [relatedObjectId]="selectedZone?.filterValue"
                  [disabled]="applicableAreaFilters.length === 0"
                  (onFilterUpdate)="handleFilterChange($event)">
                </app-filter-dropdown-new>
                <span class="subtext mt-1 mt-sm-0">{{
                  T.common.which_items_are_affected | translate: { items: localisedAreas }
                }}</span>
              </div>

              <div class="col-md-12 marginless-search-dropdown">
                <app-incident-map
                  [defaultZoom]="15"
                  [lat]="incident.latitude"
                  [lng]="incident.longitude"
                  [selectedZones]="mapZones"
                  [selectedAreas]="mapAreas"
                  [showIncidentZonesUponLoad]="true"
                  [markerColor]="severityColor"
                  [markerType]="markerType"
                  [editMode]="true"
                  (onLocationUpdated)="onIncidentLocationUpdated($event)">
                </app-incident-map>
              </div>
            </section>
          </ng-template>
        </app-accordion-item-details>
        <app-accordion-item-details [title]="T.common.assign | translate" [expanded]="false">
          <ng-template accordionContent>
            <section class="row col-row-space custom-gutters section-padding">
              <div class="col-12 qa-incident-owner">
                <app-filter-dropdown-new
                  [filterByModuleObjectType]="false"
                  [filterType]="filterTypes.Owner"
                  [appliedFilters]="filters"
                  [typeahead]="true"
                  [label]="T.common.add_owner.many | translate"
                  (onFilterUpdate)="handleFilterChange($event)">
                </app-filter-dropdown-new>
                <div class="subtext mt-1 mt-sm-0">
                  <app-button-transparent
                    size="small"
                    icon="add"
                    [text]="T.common.assign_me | translate"
                    (clicked)="setAccountForCurrentOwner()">
                  </app-button-transparent>
                </div>
                <span class="subtext mt-1 mt-sm-0">{{
                  T.common.which_individuals_are_involved_and_should_be_notified | translate
                }}</span>
              </div>

              <div class="col-12 qa-external-user">
                <app-filter-dropdown-new
                  [filterByModuleObjectType]="false"
                  [filterType]="filterTypes.External_User"
                  [appliedFilters]="filters"
                  [typeahead]="true"
                  [singleSelect]="true"
                  [currentlySelectedSettingValue]="currentlySelectedExternalUser?.filterValue"
                  [label]="T.settings.employees_departments_org.external_user | translate"
                  (onFilterUpdate)="handleFilterChange($event, filterTypes.External_User)">
                </app-filter-dropdown-new>
                <div class="subtext mt-1 mt-sm-0">
                  <app-button-transparent
                    size="small"
                    icon="add"
                    [text]="T.settings.employees_departments_org.add_new_external_user | translate"
                    (clicked)="addNewExternalUser()">
                  </app-button-transparent>
                </div>
                <span class="subtext mt-1 mt-sm-0">{{
                  T.common.which_individuals_are_involved_and_should_be_notified | translate
                }}</span>
              </div>

              <div class="col-12 qa-incident-department">
                <app-filter-dropdown-new
                  [filterByModuleObjectType]="false"
                  [filterType]="filterTypes.Department"
                  [appliedFilters]="filters"
                  [typeahead]="true"
                  [label]="T.common.add_item | translate: { item: localisedDepartments }"
                  (onFilterUpdate)="handleFilterChange($event)">
                </app-filter-dropdown-new>
                <div class="subtext mt-1 mt-sm-0" *ngIf="currentEmployee?.departmentId > 0">
                  <app-button-transparent
                    size="small"
                    icon="add"
                    [text]="T.common.assign_my_localisedDepartment | translate: { localisedDepartment: localisedDepartments }"
                    (clicked)="setMyDepartment()"
                  ></app-button-transparent>
                </div>
                <span class="subtext mt-1 mt-sm-0">{{
                  T.common.which_items_are_involved | translate: { items: localisedDepartments }
                }}</span>
              </div>

              <div class="col-12 qa-incident-owner">
                <app-filter-dropdown-new
                  [filterByModuleObjectType]="false"
                  [filterType]="filterTypes.User_Group"
                  [appliedFilters]="filters"
                  [typeahead]="true"
                  [label]="T.common.add_employee_group.many | translate"
                  (onFilterUpdate)="handleFilterChange($event)">
                </app-filter-dropdown-new>
                <span class="subtext mt-1 mt-sm-0">{{
                  T.common.which_groups_of_localisedEmployees_should_be_notified
                    | translate: { localisedEmployees: objectTypes.Employee | localiseObjectType: true }
                }}</span>
              </div>
            </section>
          </ng-template>
        </app-accordion-item-details>
        <app-accordion-item-details [title]="T.common.uploads | translate" [expanded]="false">
          <ng-template accordionContent>
            <section class="row col-row-space custom-gutters section-padding">
              <div class="col-12">
                <app-document-upload
                  [globalObjectId]="0"
                  [globalObjectType]="objectType"
                  [uploadViewModels]="uploadDocumentViewModels"
                  [handleUpdatesInternally]="false"
                  (uploadViewModelsChanged)="updateUploadViewModels($event)">
                </app-document-upload>
              </div>
            </section>
          </ng-template>
        </app-accordion-item-details>
        <app-accordion-item-details [title]="T.defaultLocalizations.tag.many | translate" [expanded]="false">
          <ng-template accordionContent>
            <section class="row col-row-space custom-gutters section-padding">
              <div class="col-12 qa-incident-tags">
                <app-add-modal-tag-groups
                  [showTitle]="false"
                  [filters]="filters"
                  [layoutClasses]="'col-12'"
                  [tagGroupObjectType]="objectType"
                  (onFiltersUpdated)="handleFilterChange($event)"
                ></app-add-modal-tag-groups>
              </div>
            </section>
          </ng-template>
        </app-accordion-item-details>
      </app-accordion-details>
    </app-modal-body>

    <app-modal-footer>
      <app-button-rectangle
        class="d-none d-md-block modal-cancel"
        [size]="'large'"
        [text]="T.common.cancel | translate"
        [buttonTheme]="'white'"
        (clicked)="onCancel()">
      </app-button-rectangle>
      <app-button-rectangle
        [size]="'large'"
        [loading]="loading"
        class="modal-saveAndExit"
        [buttonTheme]="'primary'"
        [text]="T.common.save | translate"
        [disabled]="!isTheFormValid()"
        (clicked)="onSaveAndExit()">
      </app-button-rectangle>
    </app-modal-footer>
  </ng-container>
</app-modal>
